import { FullSearchResponseData, LoadingStatus, SearchContentSection } from '@api/types';
import {
  SearchResultTabs,
  SearchResultsPagination,
  SearchResultsSections,
  SearchResultsTitle,
} from '@components';
import { Box, Stack } from '@mui/material';
import { styled } from '@mui/system';

// STYLES
//--------
const SearchResultsWrapper = styled(Box)`
  // Your styles here
`;

/**
 * Properties
 */
export type FullSearchResultsProps = LoadingStatus & {
  results?: FullSearchResponseData;
  statuses: { [Key in SearchContentSection]: LoadingStatus };
  itemsPerPage?: number;
};

/**
 * Display Full Search Results
 * Switch Modes
 */
export const FullSearchResults = ({
  itemsPerPage,
  isLoading,
  isFetching,
  statuses,
}: FullSearchResultsProps) => {
  const isWorking = isLoading || isFetching;
  return (
    <SearchResultsWrapper>
      <Box
        sx={{
          mb: {
            xs: 4,
            md: 2,
          },
        }}
      >
        <SearchResultsTitle isWorking={isWorking} />
      </Box>
      <Stack
        spacing={{
          xs: 0,
          md: 2,
        }}
      >
        <SearchResultTabs isWorking={isWorking} />
        <SearchResultsSections statuses={statuses} />
        <SearchResultsPagination itemsPerPage={itemsPerPage} />
      </Stack>
    </SearchResultsWrapper>
  );
};
